import { render, staticRenderFns } from "./ComputeResult.vue?vue&type=template&id=264c43f7&"
import script from "./ComputeResult.vue?vue&type=script&lang=js&"
export * from "./ComputeResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports